define('home/models/FollowRecommendationFeed',[
    'underscore',

    'core/api',

    'home/activityExpander',
    'home/models/Feed',
    'home/collections/FollowRecommendationCollection',
], function (
    _,

    api,

    activityExpander,
    Feed,
    FollowRecommendationCollection
) {
    'use strict';

    var FollowRecommendationFeed = Feed.extend({
        defaults: {
            fetchOptions: {
                limit: 3,
            },
        },

        initialize: function (attrs, options) {
            options = options || {};
            options.collectionClass = FollowRecommendationCollection;

            return Feed.prototype.initialize.call(this, attrs, options);
        },
    }, {
        // Factory methods for creating common FollowRecommendationFeeds:
        // users and forums
        createUserFollowRecommendationFeed: function (attrs) {
            attrs = attrs || {};

            return new FollowRecommendationFeed(attrs, {
                collectionOptions: {
                    expander: _.bind(activityExpander.buildUser, activityExpander),
                },
                collectionUrl: api.getURL('users/interestingUsers'),
            });
        },

        createForumFollowRecommendationFeed: function (attrs) {
            attrs = attrs || {};

            return new FollowRecommendationFeed(attrs, {
                collectionOptions: {
                    expander: _.bind(activityExpander.buildForum, activityExpander),
                },
                collectionUrl: api.getURL('forums/interestingForums'),
            });
        },
    });

    return FollowRecommendationFeed;
});

